export const mailMergeOwnerFields = [
  {
    value: 'FirstName',
    label: 'First Name',
    dataType: 'string',
  },
  {
    value: 'LastName',
    label: 'Last Name',
    dataType: 'string',
  },
  {
    value: 'email',
    label: 'Email Address',
    dataType: 'string',
  },
] as const;

export const accountFields = [
  {
    value: 'CurrentTime',
    label: 'Current Time',
    dataType: 'datetime',
  },
] as const;
